
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Heart, Users, Settings } from 'lucide-react';

const V2Navigation = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/v2/patients', label: 'For Patients', icon: Heart },
    { path: '/v2/partners', label: 'For Partners', icon: Users },
    { path: '/v2/staff', label: 'For Staff', icon: Settings }
  ];

  return (
    <nav className="bg-white/90 backdrop-blur-sm border-b border-juv-rose-clay/20 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-2xl font-bold text-juv-terracotta">
            JUV <span className="text-sm font-normal text-juv-deep-chestnut">2.0</span>
          </Link>
          
          <div className="flex items-center space-x-8">
            {navItems.map(({ path, label, icon: Icon }) => (
              <Link
                key={path}
                to={path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-full transition-colors ${
                  location.pathname.startsWith(path)
                    ? 'bg-juv-terracotta text-white'
                    : 'text-juv-deep-chestnut hover:bg-juv-soft-blush/30'
                }`}
              >
                <Icon className="h-4 w-4" />
                <span className="font-medium">{label}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default V2Navigation;
